"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FMService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var ServiceAddress_service_1 = require("./ServiceAddress.service");
var User_service_1 = require("./User.service");
var Http_service_1 = require("./http/Http.service");
var PreloadData_service_1 = require("./PreloadData.service");
var FMService = /** @class */ (function () {
    function FMService(httpService, userService, serviceAddressService, featureToggles, preloadDataService) {
        this.httpService = httpService;
        this.userService = userService;
        this.serviceAddressService = serviceAddressService;
        this.featureToggles = featureToggles;
        this.preloadDataService = preloadDataService;
    }
    FMService.prototype.initializeFMSToggleSettings = function (defaultFeatureToggles) {
        var _this = this;
        if (defaultFeatureToggles === void 0) { defaultFeatureToggles = null; }
        return new Promise(function (resolve) {
            var preloadData = _this.preloadDataService.getPreloadData();
            var preloadFMSToggles = (preloadData || {}).fmsFeatureToggles;
            if (!preloadFMSToggles) {
                _this.serviceAddressService.getServiceAddressByKey('fms').then(function (baseURL) {
                    var url = baseURL + "/api/fms/v1/tenants/" + _this.userService.getTenant() + "/features";
                    _this.httpService.get(url, {
                        cache: 'local',
                        cacheExpirationMinutes: 5,
                    }).then(function (result) {
                        _this.featureToggles = result;
                        resolve(result);
                    }).catch(function () {
                        if (defaultFeatureToggles)
                            _this.featureToggles = defaultFeatureToggles;
                        resolve(null);
                    });
                });
            }
            else {
                _this.featureToggles = preloadFMSToggles;
                resolve(preloadFMSToggles);
            }
        });
    };
    FMService.prototype.getFMSToggleValue = function (toggleKey, optionKey, optionValue, defaultValue) {
        if (optionKey === void 0) { optionKey = null; }
        if (optionValue === void 0) { optionValue = null; }
        if (defaultValue === void 0) { defaultValue = null; }
        var systemLevelDefaultValue = false;
        try {
            if (this.featureToggles === null) {
                console.error("FMS: can't not get feature toggles from FMS server. Toggle key is " + toggleKey + ", Option key is " + optionKey + ", Option value is " + optionValue);
                return defaultValue !== null ? defaultValue : systemLevelDefaultValue;
            }
            if (!Array.isArray(this.featureToggles)) {
                console.error("FMS: Feature toggle structure format is not correct. Toggle key is " + toggleKey + ", Option key is " + optionKey + ", Option value is " + optionValue);
                return defaultValue !== null ? defaultValue : systemLevelDefaultValue;
            }
            var featureToggle = this.featureToggles.find(function (item) { return item.key.toUpperCase() === toggleKey.toUpperCase(); });
            if (featureToggle) {
                if (optionKey !== null) {
                    var featureToggleOption = featureToggle.options.find(function (item) { return item.key.toUpperCase() === optionKey.toUpperCase(); });
                    if (!!featureToggleOption && optionValue !== null) {
                        return featureToggle.options.find(function (item) { return item.value.toUpperCase() === optionValue.toUpperCase(); }) ? true : false;
                    }
                    else {
                        console.error("FMS: can't find the feature toggle option. Toggle key is " + toggleKey + ", Option key is " + optionKey + ", Option value is " + optionValue);
                        return defaultValue !== null ? defaultValue : systemLevelDefaultValue;
                    }
                }
                else {
                    return featureToggle.toggle.value;
                }
            }
            else {
                console.error("FMS: can't find the feature toggle key. Toggle key is " + toggleKey + ", Option key is " + optionKey + ", Option value is " + optionValue);
                return defaultValue !== null ? defaultValue : systemLevelDefaultValue;
            }
        }
        catch (err) {
            console.error("FMS: getFMSToggleValue function error. error is " + err.message);
            return defaultValue !== null ? defaultValue : systemLevelDefaultValue;
        }
    };
    FMService = __decorate([
        CommonService_decorator_1.CommonService('FMService'),
        __metadata("design:paramtypes", [Http_service_1.HttpService,
            User_service_1.UserService,
            ServiceAddress_service_1.ServiceAddressService, Array, PreloadData_service_1.PreloadDataService])
    ], FMService);
    return FMService;
}());
exports.FMService = FMService;
//# sourceMappingURL=FMS.service.js.map